const toggleFullscreen = enable => {

  let fullscreenEnabled =
    document.fullscreenEnabled ||
    document.msFullscreenEnabled ||
    document.mozFullScreenEnabled ||
    document.webkitFullscreenEnabled;

  let docElm = document.documentElement;

  if (enable) {
    if (docElm.requestFullscreen) {
      docElm.requestFullscreen();
    } else if (docElm.mozRequestFullScreen) {
      docElm.mozRequestFullScreen();
    } else if (docElm.webkitRequestFullScreen) {
      docElm.webkitRequestFullScreen();
    } else if (docElm.msRequestFullscreen) {
      docElm.msRequestFullscreen();
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }

}
export default toggleFullscreen;


// WEBPACK FOOTER //
// ./src/app/toggleFullscreen.js